const Cookie = require('js-cookie');

const getAuth = () => JSON.parse(Cookie.get('auth'));

const currentUser = ()=> getAuth().user.first_name;

const PROFILE = {
    BROKER: 'BROKER',
    EXECUTIVE: 'EXECUTIVE',
    TECHNICAL: 'TECHNICAL',
    EMISSION: 'EMISSION',
}
const EXECUTIVE_TYPE = {
    EXECUTIVE_OPERATIVE: 'EXECUTIVE_OPERATIVE',
    EXECUTIVE_TEAM_SUPERVISOR: 'EXECUTIVE_TEAM_SUPERVISOR',
    EXECUTIVE_NATIONAL_SUPERVISOR: 'EXECUTIVE_NATIONAL_SUPERVISOR' ,
    EXECUTIVE_MANAGER: 'EXECUTIVE_MANAGER',
 }
const TECHNICAL_TYPE = {
    TECHNICAL_OPERATIVE: 'TECHNICAL_OPERATIVE',
    TECHNICAL_TEAM_SUPERVISOR: 'TECHNICAL_TEAM_SUPERVISOR',
    TECHNICAL_NATIONAL_SUPERVISOR: 'TECHNICAL_NATIONAL_SUPERVISOR',
    TECHNICAL_MANAGER: 'TECHNICAL_MANAGER',
}
const BROKER_TYPE = {
    BROKER_OPERATIVE: 'BROKER_OPERATIVE',
    BROKER_ADMINISTRATOR: 'BROKER_ADMINISTRATOR',
}
//BROKER
const isBroker = ()=> getAuth().user.profile === PROFILE.BROKER;
const isBrokerOperative = ()=> getAuth().user.profile_level ===  BROKER_TYPE.BROKER_OPERATIVE;
const isBrokerAdministrator = ()=> getAuth().user.profile_level === BROKER_TYPE.BROKER_ADMINISTRATOR;
//EXECUTIVE
const isExecutive = ()=> getAuth().user.profile === PROFILE.EXECUTIVE;
const isExecutiveOperative = ()=> getAuth().user.profile_level === EXECUTIVE_TYPE.EXECUTIVE_OPERATIVE;
const isExecutiveTeamSupervisor = ()=> getAuth().user.profile_level === EXECUTIVE_TYPE.EXECUTIVE_TEAM_SUPERVISOR;
const isExecutiveNationalSupervisor = ()=> getAuth().user.profile_level === EXECUTIVE_TYPE.EXECUTIVE_NATIONAL_SUPERVISOR;
const isExecutiveManager = ()=> getAuth().user.profile_level === EXECUTIVE_TYPE.EXECUTIVE_MANAGER;
//TECHNICAL
const isTechnical = ()=> getAuth().user.profile === PROFILE.TECHNICAL;
const isTechnicalOperative = () => getAuth().user.profile_level === TECHNICAL_TYPE.TECHNICAL_OPERATIVE;
const isTechnicalTeamSupervisor = () => getAuth().user.profile_level === TECHNICAL_TYPE.TECHNICAL_TEAM_SUPERVISOR;
const isTechnicalNationalSupervisor = () => getAuth().user.profile_level === TECHNICAL_TYPE.TECHNICAL_NATIONAL_SUPERVISOR;
const isTechnicalManager = () => getAuth().user.profile_level === TECHNICAL_TYPE.TECHNICAL_MANAGER;
//EMISSION
const isEmission = () => getAuth().user.profile === PROFILE.EMISSION;

const isRoleOperative = () => isExecutiveOperative() || isBrokerOperative() || isTechnicalOperative();
const isRoleAdministrator = () => isExecutiveNationalSupervisor() || isBrokerAdministrator() || isTechnicalNationalSupervisor();
const isRoleTeamSupervisor = () => isExecutiveTeamSupervisor() || isTechnicalTeamSupervisor();
const isRoleManager = () => isExecutiveManager() || isTechnicalManager();
export {
    isBroker,
    isBrokerOperative,
    isBrokerAdministrator,
    isExecutive,
    isExecutiveOperative,
    isExecutiveTeamSupervisor,
    isExecutiveNationalSupervisor,
    isExecutiveManager,
    isTechnical,
    isTechnicalOperative,
    isTechnicalTeamSupervisor,
    isTechnicalNationalSupervisor,
    isTechnicalManager,
    isEmission,
    isRoleOperative,
    isRoleAdministrator,
    isRoleTeamSupervisor,
    isRoleManager,
    currentUser,
}
